import webtmsBackend from '@/services/webtmsBackend';
import { getUserOption, findUserOptions } from '../utils/options';
import { defaultTicketFields, defaultTicketFilters, defaultFiltersDisplay, defaultClipboardFields } from './ticketDataHelpers';
import store from '../store';
import { router } from '../router';

export async function setMemberFilter(memberCode) {
    // Set filters to the default filters
    let filters = defaultTicketFilters;
    filters = resetFilters(filters);
    // Add the member filter
    filters.member_code = memberCode;
    await getDashboardTab(filters);

}

export async function setPriorityTypeCategoryFilter(priority, type, category) {

    // Set filters to the default filters
    let filters = defaultTicketFilters;
    filters = resetFilters(filters);
    // Add the PriorityTypeCategory filter
    filters.priority = priority;
    filters.type = type;
    filters.category = category;
    await getDashboardTab(filters);
}
export async function setCountyFilter(fips) {
    // Set filters to the default filters
    let filters = defaultTicketFilters;
    filters = resetFilters(filters);
    // Add the county filter
    filters.fips = fips;
    await getDashboardTab(filters);
}
export async function setLocatorFilter(locator) {
    // Set filters to the default filters
    let filters = defaultTicketFilters;
    filters = resetFilters(filters);
    // Add the county filter
    filters.locator = locator;
    await getDashboardTab(filters);
}
export async function setTicketFilter(ticketFilter) {
    // Set filters to the default filters
    let filters = defaultTicketFilters;
    filters = resetFilters(filters);

    const today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    if (day < 10) {
        day = '0' + day;
    }

    if (month < 10) {
        month = '0' + month;
    }

    // Add the ticket filter
    ticketFilter = ticketFilter.replace(/\s/g, '').toUpperCase();
    switch (ticketFilter) {
        case 'OPEN':
            // filters.stype = 'OPEN';
            break;
        case 'UN-ASSIGNED':
            filters.stype = 'IR';
            filters.TR_stage = 'IR';
            break;
        case 'ASSIGNED':
            filters.stype = 'AL';
            filters.TR_stage = 'AL';
            break;
        case 'EMERGENCY':
            filters.stype = 'emergency';
            break;
        case 'DAMAGE':
            filters.stype = 'damage';
            break;
        case 'TODAY':
            filters.seq_date = `${year}-${month}-${day}`;
            break;
        default:
            filters = defaultTicketFilters;
    }
    await getDashboardTab(filters);
}

async function getDashboardTab(filters) {
    let ticketTabs = await getTicketTabs();
    let dashboardTab = ticketTabs.find(tab => tab.label === 'Dashboard');

    if (!dashboardTab) {
        await addTicketTab('Dashboard');
        ticketTabs = await getTicketTabs();
        dashboardTab = ticketTabs.find(tab => tab.label === 'Dashboard');
    }
    // Set the filters on the tab
    await setTicketTab(dashboardTab.tabId, filters);
    // Set the tab as the selected tab
    let activeTab = {
        tabId: dashboardTab.tabId,
        label: dashboardTab.label,
    };
    store.commit('SET_ACTIVE_TAB', activeTab);
    // Navigate to the tab
    router.push('/tickets');
}
function getTicketTabs() {
    const existingTabs = [];
    let openTicketTab = getUserOption('JSON:TAB:open-tickets');

    if (openTicketTab) {
        openTicketTab = JSON.parse(openTicketTab);
    } else {
        openTicketTab = defaultOpenTicketsTabOptions();
    }

    let clipboardTab = getUserOption('JSON:TAB:tickets-clipboard');
    if (clipboardTab) {
        clipboardTab = JSON.parse(clipboardTab);
    } else {
        clipboardTab = {
            tabId: 'tickets-clipboard',
            label: 'Clipboard',
        };
    }
    clipboardTab.isClipboard = true;
    let userTabs = findUserOptions('JSON:TAB:open-tickets--')
        .map(tab => {
            let parsed = JSON.parse(tab);
            parsed.removeable = true;
            return parsed;
        })
        .sort((a, b) => Number(a.tabMoniker) - Number(b.tabMoniker));

    let returnTabs = [];
    if (clipboardTab) {
        returnTabs = [openTicketTab, ...userTabs, clipboardTab];
    } else {
        returnTabs = [openTicketTab, ...userTabs];
    }
    for (let tab of existingTabs) {
        if (!tab.isClipboard) {
            let foundTab = returnTabs.find(returnTab => returnTab.tabId === tab.tabId);
            if (foundTab) {
                foundTab.ticketCount = tab.ticketCount;
            }
        }
    }
    return returnTabs;
}
async function setTicketTab(tabId, filters) {
    // Save user options
    let options = [];
    const JSONTAB = 'JSON:TAB:' + tabId;
    let JSONTAB_DATA = await getUserOption(JSONTAB);
    if (JSONTAB_DATA == undefined) {
        JSONTAB_DATA = [];
    }
    // Get user options from store
    options.push([JSONTAB, JSONTAB_DATA]);

    let optionValue = options[0][1];
    optionValue = JSON.parse(optionValue);

    // New settings
    optionValue._TIMESTAMP_ = (new Date()).toISOString();
    optionValue.config.filters = filters;
    options[0][1] = JSON.stringify(optionValue, undefined, 2);

    // Save options to backend via store action
    await store.dispatch('updateUserOptions', options);
}
async function addTicketTab(label) {
    let newTab = {
        label: label
    };
    const result = await webtmsBackend.addNewTicketTab(newTab);
    if (result.failed.length) {
        console.error('addTicketTab failed with ', result.failed);
    } else {
        let newTab = JSON.parse(result.set[0][1]);

        // update the store
        const JSONTAB = 'JSON:TAB:' + newTab.tabId;

        let options = [];
        options.push([JSONTAB, JSON.stringify(newTab)]);
        await store.dispatch('updateUserOptions', options);
    }
}
function defaultOpenTicketsTabOptions() {
    const optionsSetting = {
        _TIMESTAMP_: '',
        tabClass: 'open-tickets',
        tabMoniker: '',
        tabId: 'open-tickets',
        label: 'Tickets',
        config: {
            autoRefreshMinutes: 0,
            pageSize: 100,
            orderBy: 'seq_date-asc',
            orderByDefault: 'seq_date-asc',
            fields: defaultTicketFields,
            filters: defaultTicketFilters,
            filtersDisplay: defaultFiltersDisplay,
        },
    };
    return optionsSetting;
}
function resetFilters(filters) {
    for (let filter in filters) {
        filters[filter] = '*';
    }
    return filters;
}
export default {
    setMemberFilter,
    setTicketFilter,
    setPriorityTypeCategoryFilter,
    setCountyFilter
};